import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: 'not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit {
  ngOnInit(): void {}
}
